import React from 'react'
import { Collection, ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import * as UI from 'ui'
import { CardGroup, CardWithHeader } from 'ui'
import ChecklistName from 'support/displays/ChecklistName'
import { ChecklistActivity } from 'support/displays/ChecklistActivity'
import { ChecklistProgress } from 'support/displays/ChecklistProgress'
import { Link } from '@morningtrain/react-navigation'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import * as Displays from 'support/displays'
import { SelectedDepartmentFilter } from 'support/filters'
import AdminPage from 'pages/app/AdminPage'
import { useEnvValue } from '@morningtrain/react-helpers'
import { StaticFilter } from '@morningtrain/react-filters'

export default function TabletChecklist () {
  const [availableScheduleCategories] = useEnvValue('user.available_schedule_categories', [])

  return (
    <WhenDeviceAuthorized>
      <AdminPage>
        <CardGroup className='mb-20'>
          {availableScheduleCategories.map(category => (
            <Collection key={category} operationContext={{ category }} resourceName='checklists.checklists'>
              <SelectedDepartmentFilter />
              <StaticFilter name='category' value={category} />
              <ForEachModel>
                <CardWithHeader header={<Displays.Enum name='key' enum='employment_type_category' />}>
                  <Translator namespace='checklists.columns'>
                    <ValueToCollection name='collection'>
                      <Table>
                        <Columns.Text
                          name='list' label={<Translation name='list' />}
                          display={<ChecklistName />}
                        />
                        <Columns.DateTime name='fill_at' />
                        <Columns.Text
                          name='activity' label={<Translation name='activity' />}
                          display={<ChecklistActivity />}
                        />
                        <Columns.Text
                          name='progress' label={<Translation name='progress' />}
                          display={<ChecklistProgress />}
                        />
                        <Columns.Column>
                          <Link route='app.view_checklist' parameters={{ checklist: 'model:id' }} className='block'>
                            <UI.SquareButton color='lightgray' className='p-2'>
                            <UI.Icons.ArrowRight />
                          </UI.SquareButton>
                          </Link>
                        </Columns.Column>
                      </Table>
                    </ValueToCollection>
                  </Translator>
                </CardWithHeader>
              </ForEachModel>
            </Collection>
          ))}
        </CardGroup>
      </AdminPage>
    </WhenDeviceAuthorized>
  )
}
